import { createContext } from 'react';

export type ToastSeverity = 'success' | 'warning' | 'error';

/** Raise a toast. `severity` defaults to `success`. */
export type ShowToast = (message: string, severity?: ToastSeverity) => void;

export const ToastContext = createContext<ShowToast | null>(null);
